import { controls } from "../../controls";

const rp456 = {
  label: "Agri Namuna No. 6",
  pageLabel: "Agri Namuna No. 6",
  starting: true,
  url: "rp456",
  //formActions: { edit: { allow: true }, delete: { allow: true }, audit: { allow: true } },
  pageType: "history", //pageType: "report",
  // formTabs: {
  //   allTabs: [
  //     {
  //       label: "Basic Info",
  //       uid: "create",
  //       style: { fontFamily: "verdana" }
  //     }
  //   ]
  // },
  filter: [

    ...controls.displayText({ tab: "filter", label: "Taluka", width: "col-sm-2" }),
    ...controls.Taluka({ tab: "filter" }),
    ...controls.showData({ tab: "filter", data: "taluka_display", name: "taluka_display", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "Parent Branch", width: "col-sm-2" }),
    ...controls.branch({ tab: "filter", defaultValue: "assigned_branch" }),
    ...controls.showData({ tab: "filter", data: "branch_display", name: "branch_display", width: "col-sm-2", displaytype: 'small' }),

    ...controls.displayText({ tab: "filter", label: "As on Date", star: true, width: "col-sm-2 " }),
    ...controls.magicDate({ tab: "filter", isRequired: true, name: "as_on_date", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2 " }),

    ...controls.displayText({ tab: "filter", label: "September Date", width: "col-sm-2 " }),
    ...controls.magicDate({ tab: "filter", name: "september_date", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2 " }),

    ...controls.displayText({ tab: "filter", label: "October Date", width: "col-sm-2 " }),
    ...controls.magicDate({ tab: "filter", name: "october_date", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2 " }),

    ...controls.displayText({ tab: "filter", label: "November Date", width: "col-sm-2 " }),
    ...controls.magicDate({ tab: "filter", name: "november_date", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2 " }),

    ...controls.displayText({ tab: "filter", label: "December Date", width: "col-sm-2 " }),
    ...controls.magicDate({ tab: "filter", name: "december_date", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2 " }),

    ...controls.displayText({ tab: "filter", label: "January Date", width: "col-sm-2 " }),
    ...controls.magicDate({ tab: "filter", name: "january_date", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2 " }),

    ...controls.displayText({ tab: "filter", label: "February Date", width: "col-sm-2 " }),
    ...controls.magicDate({ tab: "filter", name: "february_date", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2 " }),

    ...controls.displayText({ tab: "filter", label: "March Date", width: "col-sm-2 " }),
    ...controls.magicDate({ tab: "filter", name: "march_date", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2 " }),

    ...controls.displayText({ tab: "filter", label: "April Date", width: "col-sm-2 " }),
    ...controls.magicDate({ tab: "filter", name: "april_date", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2 " }),

    ...controls.displayText({ tab: "filter", label: "May Date", width: "col-sm-2 " }),
    ...controls.magicDate({ tab: "filter", name: "may_date", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2 " }),

    ...controls.displayText({ tab: "filter", label: "June Date", width: "col-sm-2 " }),
    ...controls.magicDate({ tab: "filter", name: "june_date", width: "col-sm-2" }),

  ],

  form: [],

  history: {
    perPage: 10,
    reportHeader: "Namuna No.6\nM.T. & L.T. Agri Loan - Reason wise Monthly Recoverable Amount",
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },
    displayColumns: [
      {
        Header: "Sr",
        type: "autoinc",
        accessor: "srno",
        width: 30
      },
      {
        Header: "Type of Loan",
        accessor: "descn",
        width: 250,
        rwidth: "*"
      },
      {
        Header: "Oct-20__",
        accessor: "rec_oct",
        type: "currency",
        rwidth: 50
      },
      {
        Header: "Nov-20__",
        accessor: "rec_nov",
        type: "currency",
        rwidth: 50
      },
      {
        Header: "Dec-20__",
        accessor: "rec_dec",
        type: "currency",
        rwidth: 50
      },
      {
        Header: "Jan-20__",
        accessor: "rec_jan",
        type: "currency",
        rwidth: 50
      },
      {
        Header: "Feb-20__",
        accessor: "rec_feb",
        type: "currency",
        rwidth: 50
      },
      {
        Header: "Mar-20__",
        accessor: "rec_mar",
        type: "currency",
        rwidth: 50
      },
      {
        Header: "Apr-20__",
        accessor: "rec_apr",
        type: "currency",
        rwidth: 50
      },
      {
        Header: "May-20__",
        accessor: "rec_may",
        type: "currency",
        rwidth: 50
      },
      {
        Header: "Jun-20__",
        accessor: "rec_june",
        type: "currency",
        rwidth: 50
      },
      {
        Header: "Total",
        accessor: "total",
        type: "currency",
        rwidth: 50
      }
    ]
  }
};

export default rp456;